// 用户标识颜色
export const bgColor = [
  '#FE3A2F',
  '#FF950F',
  '#FECB09',
  '#1CC759',
  '#51A9F1',
  '#0A79FE',
  '#C075DB',
  '#D8A69E',
]
// 映射语言
export const acceptLangMap = {
  en: 'en-US',
  cn: 'zh-CN',
  es: 'es-ES',
  fr: 'fr-FR',
  pl: 'pl-PL',
  pt: 'pt-PT',
  de: 'de-DE',
  it: 'it-IT',
}
// 二级分销确认协议
export const DISTRIBUTION_AGREE_KEY = 'DISTRIBUTION_AGREE_KEY'

export const storeSourceMap = {
  taobao: 'TB',
  alibaba: 'AL',
  weidian: 'WD',
  goofish: 'GF',
}
export const sourceStoreMap = {
  TB: 'taobao',
  AL: 'alibaba',
  WD: 'weidian',
  GF: 'goofish',
}
export const storeDataMap = {
  TB: 'BNM',
  AL: 'ALIBABA',
  WD: 'WEIDIAN',
  GF: 'goofish',
}

// 1）  @gmail.com
// 2)   @icloud.com
// 3)   @yahoo.com
// 4)   @outlook.com
// 5)   @hotmail.com
// 常见邮箱后缀 测试版本不全，正式需要整理
export const emailSuffix = [
  '@gmail.com',
  '@icloud.com',
  '@yahoo.com',
  '@outlook.com',
  '@hotmail.com',
  '@yahoo.cn',
  '@yahoo.com.sg',
  '@yahoo.com.au',
  '@yahoo.com.ca',
  '@msn.com',
  '@163.com',
  '@126.com',
  '@qq.com',
  '@vip.qq.com',
  '@live.cn',
]
export const checkEmailSuffix = ['@gmail.com', '@icloud.com']
export const PLATEFORM = {
  taobao: 1,
  wd: 2,
  tmall: 1,
  alibaba: 3,
}

// 部分路由退出后重定向
export const redirectPathObj = {
  // 包裹详情 -> 我的包裹
  '/person/parcel/parcelDetail': '/person/parcel/list',
  // 订单详情 -> 我的订单
  '/person/order/orderDetail': '/person/order/orderList',
  // 下单页 -> 购物车
  '/confirm': '/person/shopping/cart',
  // 提包页 -> 我的包裹
  '/submitparcel': '/person/parcel/list',
  // 站内信人工消息详情 -> 站内信
  '/person/site/reply': '/person/site/message',
  // 修改密码 -> 账户安全
  '/person/info/security/password': '/person/info/security/secenter',
  // 设置支付密码 -> 账户安全
  '/person/info/security/pay': '/person/info/security/secenter',
  // 转运订单 -> 我的订单
  '/transport': '/person/order/orderList',
  // 收银台 -> 个人中心首页
  '/payment/paycenter': '/person/pecenter',
  // 定制物流
  '/customlogic': '/person/storage/list',
}

// 以图搜物 本地存储 的key
export const IMGBASE6SEARCH = 'IMGBASE6SEARCH'
export const imageBase64 = 'IMAGEBASE64'
export const imgUrl = 'IMGURL'

// 同意条款弹窗信息
export const isAgree = 'isAgree'

// 历史搜索
export const historyText = 'historyText'

export const langList = [
  { label: 'English', value: 'en' },
  { label: 'Español', value: 'es' },
  { label: 'Polski', value: 'pl' },
  { label: 'Deutsch', value: 'de' },
  { label: 'Français', value: 'fr' },
  { label: 'Italiano', value: 'it' },
  { label: '中文(简体)', value: 'cn' },
]
// 需要绑定埋点特殊来源的渠道
export const gtagPointSource = ['facebook', 'tiktok']
